export const ROUTES_PATH = {
  // Auth
  SIGNIN: '/signin',
  FORGOT_PASSWORD: '/forgot-password',
  NEW_PASSWORD: '/new-password',
  FORGOT_PASSWORD_RESET: '/password-reset',
  ACCOUNT_MANAGER: '/account',
  ACCOUNT_DETAILS: '/account-details',
  ASSETS: '/assets',
  CAMPAIGNS: '/campaigns',
  CAMPAIGN_LOGS: '/campaigns/logs',

  // main
  DASHBOARD: '/'
}
